function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(1, 1) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React.createElement("path", {
    d: "m 72.000005,1002.3569 c -0.028,-0.715 -0.3223,-1.5414 -0.8125,-2.0626 l -16,-17.00076 c -1.0842,-0.9743 -3.16322,-1.3765 -4.37502,-0.25 -1.1936,1.1095 -1.1581,3.2613 0.031,4.3752 l 11.25002,11.9381 -31.09352,0 c -1.6568,0 -3,1.34316 -3,3.00006 0,1.6569 1.3432,3.0001 3,3.0001 l 31.09352,0 -11.25002,11.9381 c -1.0237,1.0255 -1.2129,3.253 -0.031,4.3752 1.1816,1.1221 3.33532,0.7636 4.37502,-0.2501 l 16,-17.0007 c 0.5475,-0.5818 0.8143,-1.2644 0.8125,-2.0626 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.7990b34d.svg";
export { ForwardRef as ReactComponent };